// 人件費率設定の純ロジック（Supabase 非依存＝テスト可能）。2026-08-27 一本化。
// 設定ドキュメント settings/labor: { estimatePct: number|null, updatedAt }
//   estimatePct＝「試算用」率（%・売上比）。受注試算に使い、個別設定が無い乗務員のフォールバック。
//   乗務員別の率は drivers マスタ（rates:[{from,pct}] 適用開始日つき）が正で、ここには持たない。

export const normPct = (v) => (v != null && v !== '' && !isNaN(Number(v))) ? Number(v) : null

// 試算用率の解決。settings/labor があればそれが唯一の正。
// 移行: labor ドキュメント未作成の間だけ、旧 settings/payroll.laborRatePct（#4 の旧既定歩合率）を
// 初期値として引き継ぐ。これが旧2系統への唯一の参照（読みのみ・書き込みはしない）。
export function resolveEstimatePct(laborDoc, legacyPayrollDoc) {
  if (laborDoc) return normPct(laborDoc.estimatePct)
  return normPct(legacyPayrollDoc ? legacyPayrollDoc.laborRatePct : null)
}
